namespace Core {
    export interface BookingPaymentOption {
        AdminOverride: boolean;
        CardTypeId: number;
        DataCashScheme: string; //NOT USED
        FeeAmount: number;
        FeeCap: number;
        FeePercent: number;
        FullDetails: boolean;
        ImageUrl: string;
        IsBankPayment: boolean; //NOT USED
        IsExternalFop: boolean;
        IsPayPalPayment: boolean;
        PaymentTypeId: number;
        PreAuthorisationToken: string; //NOT USED
        Title: string;
        Type: string;
    }

    export interface BookingSavedCardOption {
        CardId: string;
        CardName: string;
        CardTypeId: number;
        ExpiryMonth: number;
        ExpiryYear: number;
        IsExpired: boolean;
        LogoName: string;
        MaskedNumber: string;
        MasterCardTypeId: number;
    }

    interface BookingCardDetails {
        CardId: string;
        CardNumber: string | null;
        CardType: number | null;
        ExpiryDate: {Month: number, Year: number};
        IssueNumber: string | null;
        MaskedCardNumber: string;
        PaymentTypeId: number;
        SecurityCode: string | null;
        StartDate: {Month: number, Year: number};
    }

    export interface BookingPaymentDetails {
        CardDetails: BookingCardDetails;
        SaveThisCard: boolean;
    }

    export interface MybPaymentOption {
        AdminOverride: boolean;
        CardType: number;
        FeeAmount: number;
        FeePercent: number;
        Id: number;
        IsExternalFop: boolean;
        Name: string;
        PaymentType: number;
        PreAuthorisationToken: string; //NOT USED
    }

    export interface MybSavedCardOption {
        CardId: string;
        CardName: string;
        ExpiryMonth: number;
        ExpiryYear: number;
        FullDetailsRequired: boolean;
        IsExpired: boolean;
        LogoName: string;
        MaskedNumber: string;
        MasterCardTypeId: number;
    }

    //Our final payment option shape
    enum PaymentType {
        CreditCard = 1,
        DebitCard = 2,
        PayPal = 14
    }

    export interface PaymentOption {
        AdminOverride: boolean;
        CardTypeId: number;
        FeeAmount: number;
        FeePercent: number;
        FullDetailsRequired: boolean;
        Id: number;
        Name: string;
        PaymentType: PaymentType;
        Title: string;
        IsExternalFop: boolean;
        IsPayPal: boolean;
    }

    export interface SavedCardOption {
        CardId: string;
        CardName: string;
        CardType: number;
        ExpiryMonth: number;
        ExpiryYear: number;
        FeeAmount: number;
        FeePercent: number;
        FullDetailsRequired: boolean;
        IsExpired: boolean;
        LogoName: string;
        MaskedNumber: string;
        MasterCardTypeId: number;
        PaymentTypeId: number;
    }

    //Our model that we populate using the directive
    interface CardDate {
        month: number;
        year: number;
    }

    interface CardDetail {
        cardNumber: string | undefined; //undefined to deal with PCI field setting this
        cardTypeId: number | undefined;
        expiryDate: CardDate;
        issueNumber: string;
        maskedNumber: string;
        paymentOptionId: number; //used in MYB land
        paymentTypeId: number;
        securityCode: string | undefined; //undefined to deal with PCI field setting this
        startDate: CardDate;
        isSavedCard: boolean;
        savedCardId: string;
    }

    export interface ExternalFopDetail {
        authorisationCode: string;
        note: string;
    }

    export interface PaymentModel {
        cardDetail: CardDetail;
        externalFop: ExternalFopDetail | undefined;
        fee: number;
        isPayPalPayment: boolean;
        saveCard: boolean;
    }

    export interface FinaliseOptionsRequest {
        BookingId: number;
        AmendBookingOptionsId: string;
        PaymentId: number;
        PaRes: string;
        MD: string;
        DomainId: number;
        CultureCode: string;
    };

    export interface PaymentsUtilService {
        createEmptyPaymentModel(): PaymentModel;
        createEmptyExternalFop(): ExternalFopDetail;
        convertBookingPaymentOptions(options: BookingPaymentOption[]): PaymentOption[];
        convertBookingSavedCards(savedOptions: BookingSavedCardOption[],
                                 paymentOptions: BookingPaymentOption[]): SavedCardOption[];
        convertMybPaymentOptions(options: MybPaymentOption[]): PaymentOption[];
        convertMybSavedCards(savedOptions: MybSavedCardOption[],
                             paymentOptions: MybPaymentOption[]): SavedCardOption[];
        addPaymentDetailsToClearRequest(source: PaymentModel, target: any): void;
        copyCardDetailsToUserData(source: PaymentModel, target: BookingPaymentDetails): void;
    }
}
